export default __webpack_public_path__ + "media/zurb/img/b2b_ecommerce/le_usability-67e888fe3fc39e5df9c7a13c9a4c076d.png";